import {i18nFormatter} from './i18nFormatter';
import zappy from '@zappy-ride/library.react.components';
export * from './i18nFormatter';
zappy.FactoryInstance.registerComponent(i18nFormatter);